import {useState} from 'react';
import {RouterProvider} from '@tanstack/react-router';
import {QueryClientProvider} from '@tanstack/react-query';
import type {Deps} from './dependencies';
import {DependenciesProvider} from '@/shared/ui/contexts/dependencies';
import {ImmersiveChromeProvider} from '@/shared/ui/contexts/immersive-chrome';
import {ThemeProvider} from '@/shared/ui/contexts/theme';
import {queryClient} from './lib/query-client';
import {createAppRouter} from './router';

type AppProps = {
  deps: Deps;
};

export function App({deps}: AppProps) {
  const [router] = useState(() => createAppRouter(deps));

  return (
    <DependenciesProvider value={deps}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ImmersiveChromeProvider>
            <RouterProvider router={router} />
          </ImmersiveChromeProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </DependenciesProvider>
  );
}

export default App;
